import TableViewConversationRelation from 'mini-mail-list-store/lib/store/schema/TableViewConversationRelation';
import { action } from 'satcheljs';
/**
 * Action to update the parentFolder Id in a given table view conversation relation
 * @param tableViewConversationRelation the relation whose parent needs to be updated
 * @param parentFolderId the new parent folder id for the item
 */
export default action(
    'updateParentFolderIdInTableConversationRelation',
    function (
        tableViewConversationRelation: TableViewConversationRelation,
        parentFolderId: string
    ) {
        return { tableViewConversationRelation, parentFolderId };
    }
);
